import script from "./ViewContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewContainer.vue?vue&type=script&setup=true&lang=ts"

import "./ViewContainer.vue?vue&type=style&index=0&id=016ab20c&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-016ab20c"]])

export default __exports__